export const _translations = {
	messages: {
		en: {
			toaster: {
				more: '+{n} more',
				clearAll: 'Clear all',
			},
			buttons: {
				confirm: 'Confirm',
				cancel: 'Cancel',
			},
		},
		de: {
			toaster: {
				more: '+{n} weitere',
				clearAll: 'Alle entfernen',
			},
			buttons: {
				confirm: 'Bestätigen',
				cancel: 'Abbrechen',
			},
		},
		it: {
			toaster: {
				more: '+{n} altri',
				clearAll: 'Rimuovi tutti',
			},
			buttons: {
				confirm: 'Conferma',
				cancel: 'Annulla',
			},
		},
		fr: {
			toaster: {
				more: '+{n} autres',
				clearAll: 'Tout effacer',
			},
			buttons: {
				confirm: 'Confirmer',
				cancel: 'Annuler',
			},
		},
	},
}
